import React, { Component } from "react";
import { LoadingRow, Row, Col } from "src/views/shared/components";
import * as s from "./LoadingRowItem.module.scss";

export class LoadingRowItem extends Component {
  render() {
    return (
      <>
        <div className={s.documentRow}>
          <div className={s.loadingContainer}>
            <Row>
              <Col xs={3} className={s.loadingImageSkeleton}>
                <LoadingRow width={190} height={250} fixed />
              </Col>
              <Col xs={9}>
                <LoadingRow
                  width={150}
                  style={{ display: "block", marginBottom: "10px" }}
                />
                <LoadingRow
                  width={400}
                  height={30}
                  style={{ display: "block", marginBottom: "10px" }}
                />
                <LoadingRow
                  width={150}
                  style={{ display: "block", marginBottom: "30px" }}
                />
                <LoadingRow
                  width={500}
                  height={80}
                  style={{ display: "block", marginBottom: "10px" }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </>
    );
  }
}
